import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzPictogramsModule, dzTarget } from '@blk/daisy/core/pictograms';
import { AnalyticsModule } from '@ddt-web/analytics';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { ConfigLayerModule } from '@ddt-web/config-layer';
import { DataServiceModule } from '@ddt-web/data-service';
import { EsgModule } from '@ddt-web/esg';
import { faSquareFull } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { EsgRatingMappingTableComponent } from './esg-rating-mapping-table/esg-rating-mapping-table.component';
import { EsgUpliftSkeletonComponent } from './esg-uplift/esg-uplift-skeleton';
import { EsgUpliftComponent } from './esg-uplift/esg-uplift.component';
import { FamilyEsgMetricsComponent } from './family-esg-metrics.component';

@NgModule({
	declarations: [FamilyEsgMetricsComponent, EsgUpliftComponent, EsgUpliftSkeletonComponent, EsgRatingMappingTableComponent],
	imports: [
		CommonModule,
		SharedModule,
		AnalyticsModule,
		CwpNgFrameworkModule,
		EsgModule,
		ConfigLayerModule,
		DataServiceModule,
		ChartModule,
		NgxSkeletonLoaderModule,
		DzIconModule.withIcons(faArrowRight),
		RouterModule.forChild([
			{ path: '', pathMatch: 'full', component: FamilyEsgMetricsComponent }
		]),
		DzPictogramsModule.register(dzTarget),
		DzIconModule.withIcons(faSquareFull)
	]
})
export class FamilyEsgMetricsModule { }
